import { StoreModel } from '../../models/Index';

export default function getSession(Store: StoreModel) {
    return {
        token: Store.accessToken,
        traceparent: Store.traceContext.traceParentHeader,

        locationId: Store.locationId,
        kioskId: Store.kioskId,
        kioskName: Store.kioskName,
        brand: Store.brand,
        language: Store.language,
        platform: Store.platform,

        messageBroker: Store.configuration.messageBroker,

        isQa: Store.isQA,
        isWithoutPrinter: Store.isProceedWithoutPrinter,
        accessCode: Store.accessCode,
    };
}
